module.exports = __webpack_public_path__ + "9c7c480c4179fc5f47f2013d3ec30e72.jpg";